import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {
  DefinitionTarget,
  IDefinition,
  IDefinitionChild,
  IDefinitionsDataResponse,
  IDefinitionUpdateResponse,
  IGlobalFilters,
} from '@boma/supplier-portal/shared/entities';
import { APP_CONFIG } from '@boma/app-config';

@Injectable({
  providedIn: 'root',
})
export class DefinitionsService {
  private base: string;
  private version: string;

  constructor(
    @Inject(APP_CONFIG) private configuration: any,
    private httpClient: HttpClient
  ) {
    this.base = configuration.apiRoute;
    this.version = configuration.apiVersion;
  }

  // This will retrieve all definitions and their children
  // If no definition is specified and only a target all top level entries for that target are retrieved
  // #Target is the type of definition   Customer = 1, Product = 2, Location = 4,

  getDefinitions(
    entityId: string,
    target: DefinitionTarget,
    definitionId: string
  ) {
    const params = {
      targets: target,
    };

    if (definitionId) {
      params['id'] = definitionId;
    }

    return this.httpClient.post<IDefinition[]>(
      `${this.base}api/v${this.version}/${entityId}/Definitions/Get`,
      params
    );
  }

  //TODO: Assign types
  getDefinitionsForTarget(entityId, targetId) {
    return this.httpClient.get<IDefinition[]>(
      `${this.base}api/v${this.version}/${entityId}/Definitions?targetId=${targetId}`
    );
  }

  //TODO: Assign types
  updateDefinitions(id, entityId, target, definitions) {
    return this.httpClient.put<IDefinitionUpdateResponse[]>(
      `${this.base}api/v${this.version}/Definitions/${id}?entityId=${entityId}&target=${target}`,
      definitions
    );
  }

  //TODO: Assign types
  updateDefinitionTitle(id, entityId, value, isSelectable = false) {
    return this.httpClient.put<IDefinition>(
      `${this.base}api/v${this.version}/${entityId}/Definitions/Update/${id}`,
      { value: value, isSelectable: isSelectable }
    );
  }

  //TODO: Assign types
  attachDefinitions(id, entityId, target, definitions) {
    console.log(id, entityId, target, definitions);
    return this.httpClient.put<IDefinitionUpdateResponse[]>(
      `${this.base}api/v${this.version}/${entityId}/Definitions/${id}?target=${target}`,
      definitions
    );
  }

  getDataForDefinitions(entityId: string, filters: IGlobalFilters) {
    return this.httpClient.post<IDefinitionsDataResponse>(
      `${this.base}api/v${this.version}/${entityId}/Definitions/Details`,
      filters
    );
  }

  createDefinition(
    type: string,
    value: string, // name
    isSelectable: boolean,
    linkId: string = null,
    target: DefinitionTarget,
    parentId: string = null,
    entityId: string,
    children: IDefinitionChild[]
  ) {
    const params = {
      type: type,
      value: value,
      isSelectable: isSelectable,
      linkId: linkId,
      targets: target,
      parentId: parentId,
      entityId: entityId,
      children: children,
    };
    return this.httpClient.post<IDefinition>(
      `${this.base}api/v${this.version}/${entityId}/Definitions`,
      params
    );
  }

  getBrands(entityId: string) {
    return this.httpClient.get(
      `${this.base}api/v${this.version}/${entityId}/Brands/All`
    );
  }
}
